import { Box, Button, Text } from "@chakra-ui/react";
import { ArrowUpRightIcon } from "@root/assets/icons/arrowup";
import { ROUTE_NAMES } from "@root/constants";
import React from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AnalysisButton, HeadingContainer } from "./style";
import { useMainChatContext } from "@root/context/kps-chat-context";

export const HeadingText: React.FC<HeadingTextProps> = ({
  text,
  fontSize = "20px",
  color = "#15161A",
  fontWeight = "600",
  header = false,
  mb = 1,
  disabled = false,
  onClick = () => {},
  loading = false,
}) => {
  const { pathname } = useLocation();
  const isPermitReview = ROUTE_NAMES.MATERIAL_CAMPARISON === pathname;
  const isMultiDoc = pathname === ROUTE_NAMES.CHECKLIST;
  const isLegalChatbot = pathname === ROUTE_NAMES.LEGAL_CHATBOT;
  const { t } = useTranslation("common");
  const { multiDocUploadView, setMultiDocUploadView } = useMainChatContext();

  const getButtonText = () => {
    if (isMultiDoc) {
      return t("upload_document.proceed_multi_doc_analysis");
    }
    if (isLegalChatbot) {
      return t("upload_document.proceed_legal_chatbot");
    }
    return t("upload_document.proceedAnalysis");
  };

  const handleClick = () => {
    if (isMultiDoc || isLegalChatbot) {
      setMultiDocUploadView(false);
    }
    onClick?.();
  };

  return (
    <HeadingContainer
      fontSize={fontSize}
      mb={mb}
      fontWeight={fontWeight}
      color={color}
    >
      <Text>{text}</Text>
      {header && (isPermitReview || isMultiDoc || isLegalChatbot) && (
        <AnalysisButton
          onClick={handleClick}
          isDisabled={disabled}
          isLoading={loading}
        >
          {getButtonText()}
          <ArrowUpRightIcon size={25} color="white" />
        </AnalysisButton>
      )}
    </HeadingContainer>
  );
};
